/* 2026-10-25 (Claude). Joel: "Yes, move the remaining shared inline blocks into cached asset files the same way, and measure before and after".
   Moved out of snippets/aoam-error-tracking.liquid so browsers cache it instead of downloading it inside every page. Same code as the inline copy it replaced, notes kept as comments (the CDN strips them).
   Edit THIS file now. Roll back: restore snippets/aoam-error-tracking.liquid from OneDrive/Documents/AOAM-Theme-Backups/2026-10-25-inline-move/ and delete this file. */
(function () {
  try {
    if (window.__aoamErrTrack) return;
    window.__aoamErrTrack = true;

    var MAX_EVENTS = 8;
    var GIVE_UP_MS = 30000;
    var sent = 0;
    var seen = {};
    var queue = [];
    var started = Date.now();
    var timer = null;

    function clip(v, n) {
      v = (v === null || v === undefined) ? '' : String(v);
      return v.length > n ? v.slice(0, n) : v;
    }

    // 2026-07-30, mobile js_error sweep. GA4 reports the Facebook, Instagram and TikTok
    // in-app browsers as plain "Safari" or "Chrome", so their injected bridge scripts
    // (_AutofillCallbackHandler, window.webkit.messageHandlers, iabjs postMessage) were
    // indistinguishable from our own bugs and made the BitWhip PDP look broken when it
    // was not. Tagging the surface makes that a one-query answer. Reads the UA string
    // only and sends a fixed label, never the raw UA. Delete this function and the
    // error_surface line in send() to roll back.
    function surface() {
      try {
        var ua = navigator.userAgent || '';
        if (/FBAN|FBAV|FB_IAB/i.test(ua)) return 'facebook-in-app';
        if (/Instagram/i.test(ua)) return 'instagram-in-app';
        if (/BytedanceWebview|TikTok|musical_ly/i.test(ua)) return 'tiktok-in-app';
        if (/Pinterest/i.test(ua)) return 'pinterest-in-app';
        if (/Snapchat/i.test(ua)) return 'snapchat-in-app';
        return 'browser';
      } catch (e) { return 'unknown'; }
    }

    function flush() {
      if (typeof window.gtag !== 'function') {
        if (Date.now() - started > GIVE_UP_MS) {
          clearInterval(timer);
          timer = null;
          queue.length = 0;
        }
        return;
      }
      if (timer) { clearInterval(timer); timer = null; }
      while (queue.length) {
        try { window.gtag('event', 'js_error', queue.shift()); } catch (e) { break; }
      }
    }

    function send(type, message, source) {
      try {
        if (sent >= MAX_EVENTS) return;
        var key = type + '|' + message + '|' + source;
        if (seen[key]) return;
        seen[key] = true;
        sent++;
        queue.push({
          error_type: clip(type, 40),
          error_message: clip(message, 100),
          error_source: clip(source, 100),
          error_page: clip(location.pathname, 100),
          error_surface: clip(surface(), 40)
        });
        flush();
        if (queue.length && !timer) timer = setInterval(flush, 500);
      } catch (e) { /* never break the page */ }
    }

    window.addEventListener('error', function (ev) {
      try {
        var el = ev.target;
        // A resource that failed to load (img, script, link, video) fires error on the
        // element itself and has no ev.message. Capture phase is the only way to see it.
        if (el && el !== window && el.tagName) {
          var url = el.src || el.href || '';
          if (!url) return;
          // Drop the query string. A failing third-party pixel can carry a token or a
          // click id there, and the path alone is enough to identify the asset.
          url = url.split('?')[0].split('#')[0];
          // 2026-07-31 kit-builder js_error audit, two refinements. Delete both to roll back.
          // 1. An <img src=""> resolves to the page's own URL, so it was reported as
          //    "img failed to load | https://antsonamelon.com/<page>", which cannot be
          //    traced to an element. Report the element's identity instead of the URL.
          if (url === location.href.split('?')[0].split('#')[0]) {
            var ident = (el.id ? '#' + el.id : '') + (el.className ? '.' + String(el.className).split(' ')[0] : '');
            send('resource', el.tagName.toLowerCase() + ' with empty src', ident || 'anonymous ' + el.tagName.toLowerCase());
            return;
          }
          // 2. Failures of known tracking scripts (doubleclick, fbevents, clarity, klaviyo,
          //    gtm, tiktok, pinterest, bing) are ad blockers doing their job. They were ~24%
          //    of all js_error rows and are not actionable, so they are skipped to keep
          //    js_error a bug signal. Own-CDN and checkout asset failures still report.
          var host = (url.match(/^https?:\/\/([^\/:]+)/) || [])[1] || '';
          var trackers = ['doubleclick.net', 'facebook.net', 'clarity.ms', 'klaviyo.com', 'googletagmanager.com', 'google-analytics.com', 'analytics.tiktok.com', 'ct.pinterest.com', 'snap.licdn.com', 'bat.bing.com', 'googleadservices.com'];
          for (var ti = 0; ti < trackers.length; ti++) {
            var td = trackers[ti];
            if (host === td || host.slice(-(td.length + 1)) === '.' + td) return;
          }
          send('resource', el.tagName.toLowerCase() + ' failed to load', url);
          return;
        }
        var where = (ev.filename || '') + (ev.lineno ? ':' + ev.lineno : '') + (ev.colno ? ':' + ev.colno : '');
        send('error', ev.message || 'unknown error', where || 'cross-origin');
      } catch (e) { /* never break the page */ }
    }, true);

    window.addEventListener('unhandledrejection', function (ev) {
      try {
        var r = ev.reason;
        var msg = (r && (r.message || r.toString && r.toString())) || 'unhandled rejection';
        var where = (r && r.stack) ? String(r.stack).split('\n')[1] || '' : '';
        send('promise', msg, where.trim() || 'no stack');
      } catch (e) { /* never break the page */ }
    });
  } catch (e) { /* never break the page */ }
})();
